import * as React from 'react';
import { Textbox, ValidationProps } from 'ui';
import { CodetableMetadata } from '../../types-store';
import { CodetableTranslation } from '../../constants';
import { getValidationWithoutDuplicates } from 'app/area/codetable/item/code-pickers/helpers';
import { CodeItem } from 'app/area/codetable/item/types-store';
import { maxIconLength } from 'app/area/codetable/item/constants';

interface CodeIconProps {
  metadata: CodetableMetadata;
  readOnly?: boolean;
  codeItem: CodeItem;
  onChange: (icon: string) => void;
  translation: CodetableTranslation;
  validation?: { [key: string]: ValidationProps };
}

export const CodeIcon = ({ metadata, readOnly, onChange, codeItem, translation, validation }: CodeIconProps) => {

  if (!metadata || !metadata.features || !metadata.features.icon) {
    return null;
  }

  const onChangeWithTrim = (icon: string) => (!!codeItem?.icon || !!icon) && onChange(icon?.trim());

  const iconValidation = !!validation && !!validation.icon ? getValidationWithoutDuplicates(validation.icon) : undefined;

  return <div className="col-lg-6 col-sm-12">
    <Textbox
      className={undefined}
      componentId="code-icon"
      readOnly={readOnly}
      onChange={onChangeWithTrim}
      label={{ text: translation.icon }}
      info={!readOnly && { text: translation.icon_description, visible: true }}
      validation={iconValidation}
      value={codeItem && codeItem.icon}
      maxLength={maxIconLength}
    />
  </div>;
};
